import { MEDIA_TYPE_LABELS } from '@/features/search/constants'
import { useSearch } from '@/features/search/hooks/useSearch'
import { useAppSelector } from '@/redux/hooks'
import { CheckboxGroup } from '../baseInputTypes/FilterCheckboxGroup'

export const MediaType = () => {
  const { selectors, updateNext } = useSearch()
  const nextSearchOptions = useAppSelector(selectors.selectNextSearchParameters)

  return (
    <CheckboxGroup
      label="Media Type"
      fieldName="mediaType"
      state={nextSearchOptions.mediaType}
      checkboxDetails={MEDIA_TYPE_LABELS}
      onChange={(key, checked) => updateNext({ mediaType: { [key]: checked } })}
    />
  )
}
